module.exports = __webpack_public_path__ + "static/dashboard_bg-db1a8d9d3d736412098071fd49be8594.png";